export default {"src":"/_next/static/media/0x514910771af9ca656af840dff83e8264ecf986ca.bc433701.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};